import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { CheckboxView } from './checkboxview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { CheckboxCSSStyle } from './checkboxcss';


export interface CheckboxProps extends UIComponentProps
{
    isEditable: boolean;
    isChecked: boolean; 
    style: CheckboxCSSStyle;
    onChange(isChecked:boolean):void;
}
export interface CheckboxState extends UIComponentState
{
    isChecked: boolean; 
    isEditable: boolean;
}

export interface CheckboxHandler extends UIComponentHandler
{  
    onClick():void; 
}

export class CheckboxComponent extends UIComponentImpl<CheckboxProps, CheckboxState, UIDataModel> implements CheckboxHandler
{
    onChange:Function = ()=>{};

    constructor(props:CheckboxProps){
        super(props);

        this.state = {isChecked: this.props.isChecked, isEditable: props.isEditable};

        if(this.props.onChange !== undefined && props.isEditable){
            this.onChange = this.props.onChange;
        }
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CheckboxView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.style;
    }

    UNSAFE_componentWillReceiveProps(newProps:CheckboxProps){
        this.setState({isChecked: newProps.isChecked, isEditable: newProps.isEditable});

        if(newProps.onChange !== undefined){
            this.onChange = newProps.onChange;
        }
    }

    onClick(){
        if(this.state.isEditable)
        {
            this.setState((state:any)=>{
                this.onChange(!state.isChecked);
                return {isChecked: !state.isChecked};
            });
        }
    }

    isChecked():boolean{
        return this.state.isChecked;
    }

    validate(): boolean{
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/checkbox/checkboxcomponent.tsx